/**
 * The set of all valid trip type codes as defined by the `kinetik-trip-service` repository.
 */
export const TRIP_TYPE_CODES = Object.freeze({
  SCHEDULED: 'SCHEDULED',
  MILEAGE_REIMBURSEMENT: 'MILEAGE_REIMBURSEMENT',
  PUBLIC_TRANSPORTATION: 'PUBLIC_TRANSPORTATION',
  ANCILLARY_SERVICES: 'ANCILLARY_SERVICES',
});

/**
 * The user-friendly labels for the trip types.
 */
export const TRIP_TYPE_LABELS = Object.freeze({
  [TRIP_TYPE_CODES.SCHEDULED]: 'Scheduled',
  [TRIP_TYPE_CODES.MILEAGE_REIMBURSEMENT]: 'Mileage Reimbursement',
  [TRIP_TYPE_CODES.PUBLIC_TRANSPORTATION]: 'Public Transport',
  [TRIP_TYPE_CODES.ANCILLARY_SERVICES]: 'Ancillary Services',
});
